const BlogDetailsSection1 = () => {
  return (
    <section className="about about--style1 bg-color xts-section py-10 px-6">
      <div className="container max-w-4xl mx-auto py-5">
          <h1 className="text-3xl text-center font-bold pb-4 text-gray-800">
            The Rise of Algorithmic Trading in India: Why Smart Investors Are Adapting
          </h1>
         <div className="row gx-5 gy-4 gy-sm-0 align-items-center">
            <div className="col-lg-6">
              <div className="about__thumb" data-aos="fade-right" data-aos-duration="800">
                <div className="about__thumb-inner">
                  <div className="about__thumb-image floating-content">
                    <img className="dark w-100" src="assets/images/blog/image-4.jpg" alt="about-image" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="about__content" data-aos="fade-left" data-aos-duration="800">
                <div className="about__content-inner">
                 
        <p className="text-lg text-gray-700 mb-4 leading-relaxed">
          Algorithmic trading is transforming how India trades. With markets becoming faster and data-driven,
          even traditional investors are shifting toward automation. Platforms like ours offer API-based execution,
          back-tested strategies, and low-latency systems, empowering traders to compete at institutional levels.
        </p>
        <p className="text-lg text-gray-700 mb-4 leading-relaxed">
          As SEBI regulations evolve, algorithmic trading is now more accessible and compliant than ever.
          Whether you’re a retail trader experimenting with automation or a professional building custom algos,
          the edge lies in speed, discipline, and consistency — not emotion.
        </p>
        <p className="text-lg text-gray-700 leading-relaxed font-semibold">
          Smart trading isn’t luck. It’s logic, powered by algorithms.
        </p>
                </div>
              </div>
            </div>
          </div>

        
      </div>
    </section>
  );
};

export default BlogDetailsSection1;
